<template>
  <div class="home">
    <Welcome />
    <Blog
      :post="post"
      v-for="(post, index) in blogPostFeed"
      :key="index"
      :number="index"
    />
    <div class="recent-section">
      <h1 class="my-5">View More Recent Blogs</h1>
      <div class="row">
        <div
          v-for="(post, index) in blogPostCards"
          :key="index"
          class="col-12 col-sm-6 col-md-4 col-lg-3 card-col"
        >
          <Card :post="post" :number="index" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Welcome from "../components/WelcomeComponent.vue";
import Blog from "../components/BlogComponent.vue";
import Card from "../components/CardComponent.vue";

export default {
  name: "Home",
  components: {
    Welcome,
    Blog,
    Card,
  },
  created() {
    if (this.$store.state.blogPosts.length === 0) {
      this.$store.dispatch("getPosts");
    }
  },
  data() {
    return {};
  },
  computed: {
    blogPostFeed() {
      return this.$store.getters.blogPostsFeed;
    },
    blogPostCards() {
      return this.$store.getters.blogPostsCards;
    },
  },
};
</script>

<style scoped>
.recent-section {
  padding: 40px 60px 40px 60px;
  background-color: #f1f1f1;
}
.card-col {
  display: flex;
  justify-content: center;
}
</style>